var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconContactNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.006,
    height: 17.038,
    viewBox: "0 0 17.006 17.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M19.172,15.006V17.42a1.609,1.609,0,0,1-1.754,1.609,15.925,15.925,0,0,1-6.945-2.47,15.692,15.692,0,0,1-4.828-4.828,15.925,15.925,0,0,1-2.47-6.977A1.609,1.609,0,0,1,4.776,3H7.19A1.609,1.609,0,0,1,8.8,4.384a10.332,10.332,0,0,0,.563,2.261A1.609,1.609,0,0,1,9,8.343L7.978,9.365a12.875,12.875,0,0,0,4.828,4.828l1.022-1.022a1.609,1.609,0,0,1,1.7-.362,10.332,10.332,0,0,0,2.261.563,1.609,1.609,0,0,1,1.384,1.634Z",
    transform: "translate(-2.667 -2.5)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactNumber);
export default __webpack_public_path__ + "static/media/icon-contact-number.1b8c77e65a0fcd7a5b4f1e887fb2d003.svg";
export { ForwardRef as ReactComponent };